<template>
  <div class="wrap-lg">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px 0">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>“{{searchText}}”的搜索结果</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="10">
      <el-col :span="18">
       <!-- <el-card shadow="hover">
          <div>
            <el-input
              style="width: 380px;"
              class="inline-input"
              v-model="searchText"
              @keyup.enter.native="mockData"
              prefix-icon="el-icon-search"
              placeholder="请输入您要搜索的关键字"
            >
              <el-button slot="append" :loading="loading" @click="mockData">搜索</el-button>
            </el-input>
          </div>
        </el-card>-->
        <el-card shadow="hover">
          <el-menu default-active="" :model="searchType" class="el-menu-demo" mode="horizontal"
                   active-text-color="#ffd04b" @select="handleChange">
            <el-menu-item index="">全部</el-menu-item>
            <el-menu-item index="test">检测服务</el-menu-item>
            <el-menu-item index="standard">检验标准</el-menu-item>
            <el-menu-item index="laws">法律法规</el-menu-item>
            <el-menu-item index="formulat">产品配方</el-menu-item>
            <el-menu-item index="solution">解决方案</el-menu-item>
            <el-menu-item index="recommend_test">推荐检测服务</el-menu-item>
          </el-menu>
        </el-card>
        <no-data-card v-if="pageParam.total === 0"></no-data-card>
        <el-card style="margin-top: 10px" v-loading="loading">
          <div>
            <div v-for="item in resources" :key="item.id">
              <div class="item" v-if="item.resourceType === 'standard'">
                <h2>
                  <my-link :href="'/standard/detail?sid='+item.id+'&viewType=2&tableType=web_test_standard'">【<span v-html="item.code"></span>】<span v-html="item.title"></span></my-link>
                  <el-tag v-if="item.isHot === '1'" size="mini" type="warning" style="margin-left: 8px;">热门</el-tag>
                  <el-tag v-if="item.isAd === '1'" size="mini" type="danger" style="margin-left: 8px;">推荐</el-tag>
                  <el-tag type="success" size="mini" style="margin-left: 8px;">检验标准</el-tag>
                </h2>
                <p><span v-html="item.description"></span></p>
                <el-divider></el-divider>
              </div>
              <div class="item" v-if="item.resourceType === 'laws'">
                <h2>
                  <my-link :href="'/laws/detail?sid='+item.id+'&viewType=2&tableType=web_laws'">【<span v-html="item.code"></span>】<span v-html="item.title"></span></my-link>
                  <el-tag size="mini" style="margin-left: 8px;">法律法规</el-tag>
                </h2>
                <p><span v-html="item.description"></span></p>
                <el-divider></el-divider>
              </div>
              <div class="item" v-if="item.resourceType === 'formulat'">
                <h2>
                  <my-link :href="'/formula/detail?sid='+item.id+'&viewType=2&tableType=web_formulat'"><span v-html="item.title"></span></my-link>
                  <el-tag v-if="item.isHot === '1'" size="mini" type="warning" style="margin-left: 8px;">热门</el-tag>
                  <el-tag v-if="item.isAd === '1'" size="mini" type="danger" style="margin-left: 8px;">推荐</el-tag>
                  <el-tag type="warning" size="mini" style="margin-left: 8px;">产品配方</el-tag>
                </h2>
                <p><span v-html="item.description"></span></p>
                <el-divider></el-divider>
              </div>
              <div class="item" v-if="item.resourceType === 'test'">
                <h2>
                  <my-link :href="'/service/detail?sid='+item.id"><span v-html="item.title"></span></my-link>
                  <el-tag v-if="item.isHot === '1'" size="mini" type="warning" style="margin-left: 8px;">热门</el-tag>
                  <el-tag v-if="item.isAd === '1'" size="mini" type="danger" style="margin-left: 8px;">推荐</el-tag>
                  <el-tag type="info" size="mini" style="margin-left: 8px;">检测服务</el-tag>
                </h2>
                <p><span v-html="item.description"></span></p>
                <el-divider></el-divider>
              </div>
              <div class="item" v-if="item.resourceType === 'recommend_test'">
                <h2>
                  <my-link :href="'/reservice/detail?sid='+item.id"><span v-html="item.title"></span></my-link>
                  <el-tag v-if="item.isHot === '1'" size="mini" type="warning" style="margin-left: 8px;">热门</el-tag>
                  <el-tag v-if="item.isAd === '1'" size="mini" type="danger" style="margin-left: 8px;">推荐</el-tag>
                  <el-tag type="primary" size="mini" style="margin-left: 8px;">推荐检测服务</el-tag>
                </h2>
                <p><span v-html="item.description"></span></p>
                <el-divider></el-divider>
              </div>
              <div class="item" v-if="item.resourceType === 'solution'">
                <h2>
                  <my-link :href="'/reservice/detail?sid='+item.id"><span v-html="item.title"></span></my-link>
                  <el-tag v-if="item.isHot === '1'" size="mini" type="warning" style="margin-left: 8px;">热门</el-tag>
                  <el-tag v-if="item.isAd === '1'" size="mini" type="danger" style="margin-left: 8px;">推荐</el-tag>
                  <el-tag type="success" size="mini" style="margin-left: 8px;">解决方案</el-tag>
                </h2>
                <p><span v-html="item.description"></span></p>
                <el-divider></el-divider>
              </div>
            </div>
          </div>
          <pagination v-bind:child-msg="pageParam" @callFather="callFather"></pagination>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <ad-right></ad-right>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getResourceLists } from '@/api/resource/resource'
export default {
  name: 'index',
  data () {
    return {
      searchText: '',
      activeIndex: '',
      searchType: '',
      loading: false,
      resources: [],
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  mounted () {
    if (this.$route.query.sq) {
      this.searchText = this.$route.query.sq
    }
    this.handleSelect()
  },
  filters: {
  },
  methods: {
    // 获取客户列表
    handleChange (key, keyPath) {
      this.searchType = key
      this.pageParam.currentPage = 1
      this.pageParam.pageSize = 10
      this.pageParam.total = 10
      this.handleSelect()
    },
    handleSelect () {
      // 请求获取数据
      let param = {}
      param.keyWord = this.searchText
      param.searchType = this.searchType
      param.page = {
        pageNum: this.pageParam.currentPage,
        pageSize: this.pageParam.pageSize
      }
      this.loading = true
      getResourceLists(param)
        .then(res => {
          this.loading = false
          var result = res.data
          if (result.rtnCode !== '0') {
            this.$message({
              type: 'info',
              message: result.msg
            })
          } else {
            this.resources = result.bizData.list
            this.resources.forEach(v => {
              v.description = this.getSimpleText(v.description)
              v.description = this.keyWordLight(v.description)
              v.title = this.keyWordLight(v.title)
            })
            // 分页赋值
            this.pageParam.total = result.bizData.total
          }
        }).catch(ex => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },
    getSimpleText (html) {
      var re1 = new RegExp('<.+?>', 'g')
      var msg = html.replace(re1, '')
      return msg
    },
    keyWordLight (val) {
      val = val + ''
      if (val.indexOf(this.searchText) !== -1 && this.searchText !== '') {
        return val.replace(this.searchText, '<span style="color: red;">' + this.searchText + '</span>')
      } else {
        return val
      }
    },
    callFather (parm) {
      this.pageParam.currentPage = parm.currentPage
      this.pageParam.pageSize = parm.pageSize
      this.handleSelect()
    }
  }
}
</script>

<style lang="scss" scoped>
  .item {
    h2 {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      padding: 0;
      margin: 0;
      a {
        text-decoration: none;
        color: #303133;
        font-size: 18px;
        font-weight: normal;
        display: inline-block;
        height: 22px;
        line-height: 22px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &:hover {
          color: #32A08C;
        }
      }
    }
    p {
      text-indent:2em;
      color: #959595;
      font-size: 14px;
      line-height: 20px;
      height: 60px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
  .highlights-text {
    color:#E6A23C;
  }
</style>
